import React from 'react'
import Header from "../components/Header/Header.jsx";
import ServicesMainPage from "../components/ServicesMainPage/ServicesMainPage.jsx";
import GoogleMap from "../components/GoogleMap/GoogleMap.jsx";

export default function Services({teamsData, activeCategory, setActiveCategory, isHidden, setIsHidden}) {
    return (
        <div>
            <Header activeCategory={activeCategory} setActiveCategory={setActiveCategory} pageServices={true}/>
            <ServicesMainPage teamsData={teamsData} isHidden={isHidden} setIsHidden={setIsHidden} activeCategory={activeCategory} setActiveCategory={setActiveCategory}/>
        </div>
    )
}
